<template>
  <div id="OperEnergy-designer">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width:40%;">
          <top-header name="topHeader" :PageTitle="PageTitle" ActiveMenuIndex="OperRouteDesigner" />
        </div>
        <div style="width:60%;">
          <el-select v-model="selectedBU" style="right:-450px;" class="block-top-button-field" placeholder="所有BU" @change="refreshDataOnChange()">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select class="block-top-button-field" style="right:-500px;" v-model="selectedPlant" placeholder="工厂" @change="loadRouteList()">
            <el-option
              v-for="item in PlantList"
              :key="item.PlantCode"
              :label="item.PlantName"
              :value="item.PlantCode"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>
      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-button">
            <el-input class="block-top-button-field" v-model="CurrentPartNo" style="width:200px;" placeholder="产品" v-show="false">
              <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer;" @click="showSearchPart()"></i>
            </el-input>
            <el-select class="block-top-button-field" v-model="selectedRoute" placeholder="选择产品工艺或新增" style="width:350px;margin-top:5px;" @change="refreshRouteFlow()">
              <el-option
                v-for="item in RouteList"
                :key="item.RouteCode"
                :label="item.RouteName"
                :value="item.RouteCode"
              ></el-option>
            </el-select>
            <el-button type="primary" style="height:40px; margin-top:5px; margin-left:10px;" icon="el-icon-circle-plus" @click="showSaveDialog()">新 增</el-button>
            <el-button type="primary" style="height:40px; margin-top:5px; margin-left:10px;" icon="el-icon-error" :disabled="true">删 除</el-button>
            <el-button type="primary" style="height:40px; margin-top:5px; margin-left:10px;" icon="el-icon-circle-check" :loading="loadingSave" @click="saveRouteFlow()">保 存</el-button>
            <el-button type="primary" style="height:40px; margin-top:5px; margin-left:10px;" icon="el-icon-refresh" @click="refreshRouteFlow()">刷 新</el-button>
            <div style="font-size:30px; display: flex; right:30px; position: absolute; margin-top:10px;">
              <i class="el-icon-zoom-in" style="padding-right:10px; cursor:pointer;" @click="cyZoomIn()"></i>
              <i class="el-icon-zoom-out" style="padding-right:10px; cursor:pointer;" @click="cyZoomOut()"></i>
              <i class="el-icon-c-scale-to-original" style="padding-right:10px; cursor:pointer;" @click="cyZoomFit()"></i>
            </div>
          </div>
          <div class="route-content">
            <el-container style="height: 500px;">
              <el-aside width="170px" style="background-color: rgb(238, 241, 246);">
                <el-input v-show="OperListArray.length>0" v-model="FilterOperKey" style="width:140px; padding-left:10px;" placeholder="筛选工艺"></el-input>
                <div v-for="item in filterOperListArray" v-bind:key="item.OperName" style="padding-bottom:10px; ">
                  <el-row>
                  <operModel 
                    :OperName="OperList[item.OperName].OperName" 
                    :OperTitle="OperList[item.OperName].OperTitle" 
                    :OperImage="OperList[item.OperName].OperImage" 
                    @click="showOperEquipment(item.OperName)" />
                  </el-row>
                </div>
              </el-aside>
              <el-main>
              <cydesigner ref="routeComponent" />
              <img id="cy_imgEdit" src="./img/Edit.png" style="display:none; visibility:hidden;" />
              </el-main>
            </el-container>
          </div>
        </div>
      </div>
      <el-dialog :title="AppendOperationTitle" :append-to-body="true" :visible.sync="dialogVisible" width="500px">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="名称">
            <el-input v-model="OperationModel_OperationName" style="width:150px;" placeholder="工艺名称">
            </el-input>
          </el-form-item>
          <el-form-item label="零件号">
            <el-input v-model="OperationModel_PartNo" style="width:150px;" placeholder="零件号">
              <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer;" @click="showSearchPart()"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="标题位置">
            <el-radio-group v-model="OperationModel_TextVAlign">
              <el-radio :label="1">上方</el-radio>
              <el-radio :label="2">下方</el-radio>
              <el-radio :label="3">左侧</el-radio>
              <el-radio :label="4">右侧</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span>
          <div v-for="item in AppendOperationEquipment" v-bind:key="item.index">
            <el-checkbox v-model="item.checked" :label="item.EquipmentName" :key="item.index" border></el-checkbox>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" :disabled="dialogRemoveButtonDisabled" @click="removeOperation()">删 除</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="appendOperation()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="SearchPartTitle" :append-to-body="true" :visible.sync="SearchPartVisible" width="800px" height="700px">
        <span>
          <el-form :inline="true" :model="SearchPart_Query" class="demo-form-inline" size="mini">
            <el-form-item label="料号">
              <el-input v-model="SearchPart_Query.PartNo" placeholder="料号"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="SearchPart_Query.Description" placeholder="描述"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchPartList()">查询</el-button>
            </el-form-item>
          </el-form>          
        </span>
        <span>
          <el-table :data="SearchPartList" stripe highlight-current-row @current-change="handleCurrentChange" height="400px">
            <el-table-column property="PartNo" label="料号" width="200"></el-table-column>
            <el-table-column property="Description" label="描述"></el-table-column>
          </el-table>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="SearchPartVisible = false">取 消</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="confirmSearchPart()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增" :append-to-body="true" :visible.sync="SaveRouteVisible" width="600px" height="500px">
        <span>
          <el-form :model="SaveRoute_Model" class="demo-form-inline">
            <el-form-item label="*产品" v-show="false">
              <el-input v-model="SaveRoute_Model.PartNo" placeholder="产品"></el-input>
            </el-form-item>
            <el-form-item label="*路径编码">
              <el-input v-model="SaveRoute_Model.RouteCode" placeholder="路径编码"></el-input>
            </el-form-item>
            <el-form-item label="*路径名称">
              <el-input v-model="SaveRoute_Model.RouteName" placeholder="路径名称"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="SaveRoute_Model.Memo" placeholder="备注"></el-input>
            </el-form-item>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-close" @click="SaveRouteVisible = false">取 消</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="confirmSaveRoute()">确 定</el-button>
        </span>
      </el-dialog>
    </dv-full-screen-container>
  </div>
</template>

<script>
import request from '@/utils/request'
import topHeader from '../TopMenu/topHeader';
import cydesigner from './cydesigner';
import operModel from './OperModel';
import { AREA_LIST, BU_LIST } from '../mainPage/area_bu'

export default {
  name: 'OperEnergy',
  components: {
    topHeader,
    cydesigner,
    operModel
  },
  data() {
    return {
      PageTitle: '设备生产工艺设计',
      dialogVisible: false,
      dialogRemoveButtonDisabled: true,
      editingNodeId: '',
      options: BU_LIST,
      PlantList: [],
      RouteList: [],
      options2: AREA_LIST,
      selectedArea: '',
      selectedBU: '',
      selectedPlant: '',
      FilterNumber: '',

      loadingSave: false,

      SearchPartTitle: '选择产品',
      SearchPartVisible: false,
      SearchPartList: [],
      SearchPart_Query: {
        PartNo: '',
        Description: ''
      },
      PartCurrentRow: { },
      CurrentPartNo: '',
      CurrentPartEntity: {},

      selectedRoute: '',
      
      OperList: {},
      OperListArray: [],
      EquipmentList: {},
      FilterOperKey: '',

      AppendOperationTitle: '',
      AppendOperationEquipment: [],
      CurrentAppendOperName: '',
      OperationModel_PartNo: '',
      OperationModel_OperationName: '',
      OperationModel_TextVAlign: '',

      SaveRouteTitle: '',
      SaveRouteVisible: false,
      SaveRoute_Model: {
        PartNo: '',
        RouteCode: '',
        RouteName: '',
        Memo: ''
      },

      fullscreenLoading: false
    }
  },
  mounted() {
    const { refreshPlantList, loadOperationList, loadRouteList } = this

    this.selectedBU = 'YFAI-AP'
    this.selectedPlant = 'YFJQ01'
    refreshPlantList()

    try {
      loadOperationList()
    } catch (ex) {
    }
    try {
      loadRouteList()
    } catch (ex) {
    }
  },
  computed: {
    filterOperListArray() {
      var key = this.FilterOperKey
      var operList = this.OperListArray
      return operList.filter(function (item) {
        return item.OperTitle.toLowerCase().indexOf(key.toLowerCase()) != -1
      })
    }
  },
  methods: {
    refreshPlantList() {
      let selBu = ''
      if (this.selectedBU !== undefined && this.selectedBU !== '') {
        selBu = this.selectedBU
      }
      const queryArgs = { QueryAreaName: this.selectedArea, QueryBU: selBu, QueryFilterBy: 'IsUpload' }
      request({
        url: 'Kanban/PlantList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.PlantList = res.data.Data.PlantList
      })
    },
    showOperEquipment(operName, operObj, equipmentList, operAttr) {
      if (this.dialogVisible == true)
        return

      this.dialogVisible = true

      this.AppendOperationTitle = ''
      this.AppendOperationEquipment = []
      this.OperationModel_TextVAlign = 'top'
      if (this.EquipmentList[operName] != undefined) {
        this.AppendOperationTitle = this.OperList[operName].OperTitle
        this.AppendOperationEquipment = JSON.parse(JSON.stringify(this.EquipmentList[operName]))
      }
      
      
      this.AppendOperationEquipment.forEach(item => {
        item.checked = false
        if (equipmentList != undefined && equipmentList.length > 0) {
          if (equipmentList.indexOf(item.EquipmentName) >= 0) {
            item.checked = true
          }
        }
      })
      this.AppendOperationEquipment = JSON.parse(JSON.stringify(this.AppendOperationEquipment))

      this.CurrentAppendOperName = operName
      if (operAttr != undefined) {
        this.OperationModel_PartNo = operAttr.PartNo
        this.OperationModel_OperationName = operAttr.OperLabel
        this.OperationModel_TextVAlign = operAttr.TextVAlign
        if (this.OperationModel_TextVAlign == 'top') {
          this.OperationModel_TextVAlign = 1
        } else if (this.OperationModel_TextVAlign == 'bottom') {
          this.OperationModel_TextVAlign = 2
        } else if (this.OperationModel_TextVAlign == 'left') {
          this.OperationModel_TextVAlign = 3
        } else if (this.OperationModel_TextVAlign == 'right') {
          this.OperationModel_TextVAlign = 4
        }
      }
      this.dialogRemoveButtonDisabled = true
      this.editingNodeId = ''
      if (operObj != undefined) {
        if (this.EquipmentList[operName] != undefined) {
          this.dialogRemoveButtonDisabled = false
        }
        this.editingNodeId = operObj
      }
    },
    appendOperation() {
      if (this.OperationModel_PartNo == '' || this.OperationModel_PartNo == undefined) {
        this.$message.error('请先填写零件号！')
        return
      }
      let operArgs = { }
      operArgs.OperId = this.editingNodeId
      operArgs.PartNo = this.OperationModel_PartNo
      operArgs.OperLabel = this.OperationModel_OperationName
      operArgs.TextVAlign = this.OperationModel_TextVAlign
      if (operArgs.TextVAlign == 1) {
        operArgs.TextVAlign = 'top'
      } else if (operArgs.TextVAlign == 2) {
        operArgs.TextVAlign = 'bottom'
      } else if (operArgs.TextVAlign == 3) {
        operArgs.TextVAlign = 'left'
      } else if (operArgs.TextVAlign == 4) {
        operArgs.TextVAlign = 'right'
      }
      if (this.OperList[this.CurrentAppendOperName] != undefined) {
        operArgs.OperDef = JSON.parse(JSON.stringify(this.OperList[this.CurrentAppendOperName]))
      }
      
      operArgs.EquipmentList = []
      this.AppendOperationEquipment.forEach(item => {
        if (item.checked) {
          operArgs.EquipmentList.push(item)
        }
      })
      this.$refs.routeComponent.appendOperation(operArgs)
      this.dialogVisible = false
    },
    removeOperation() {
      this.$confirm('此操作将删除流程中的工艺节点，请确认是否继续？')
          .then(_ => {
            this.$refs.routeComponent.removeOperation(this.editingNodeId)
            this.dialogVisible = false
          })
          .catch(_ => {});
    },
    saveRouteLayout() {
      this.$refs.routeComponent.exportCyJson()
    },
    showSearchPart() {
      this.SearchPartVisible = true
      this.SearchPartList = []
      this.PartCurrentRow = {}
    },
    searchPartList() {
      if (this.selectedPlant == '') {
        this.$message.error('请先选择工厂！')
        return
      }
      let queryArgs = {
        QueryPlantCode: this.selectedPlant,
        QueryPartNo: this.SearchPart_Query.PartNo,
        QueryPartDesc: this.SearchPart_Query.Description
      }
      request({
        url: 'Kanban/QueryPartList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        this.SearchPartList = res.data.Data
      })
    },
    handleCurrentChange(row) {
      this.PartCurrentRow = row
    },
    confirmSearchPart() {
      const { loadRouteList } = this

      if (this.PartCurrentRow == undefined || this.PartCurrentRow.PartNo == undefined) {
        this.$message.error('请先选择产品！')
        return
      }
      if (this.dialogVisible == true) {
        this.OperationModel_PartNo = this.PartCurrentRow.PartNo
        this.SearchPartVisible = false
        return
      }

      this.CurrentPartNo = this.PartCurrentRow.PartNo
      this.CurrentPartEntity = {}
      this.SearchPartList.forEach(x => {
        if (x.PartNo == this.CurrentPartNo) {
          this.CurrentPartEntity = x
          return
        }
      })

      this.SearchPartVisible = false
      loadRouteList()
      // 显示流程设计
      this.$refs.routeComponent.showEmptyFlow()
    },
    loadOperationList() {
      if (this.selectedPlant == '') {
        this.$message.error('请先选择工厂！')
        return
      }
      let queryArgs = {
        QueryPlantCode: this.selectedPlant
      }
      request({
        url: 'Kanban/PartRoute_OperationList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        var operData = res.data.Data
        this.OperList = {}
        this.OperListArray = []
        this.EquipmentList = {}
        operData.forEach(item => {
          // 工艺
          var operObj = {
            OperName: item.OperationCode,
            OperTitle: item.OperationName,
            OperImage: item.ImageUrl
          }
          this.OperList[item.OperationCode] = operObj
          this.OperListArray.push(operObj)
          // 设备
          var operEquip = []
          var equipData = item.MesEquipmentList
          equipData.forEach(equip => {
            operEquip.push({
              EquipmentNo: equip.EquipmentNo,
              EquipmentName: equip.EquipmentName
            })
          })
          this.EquipmentList[item.OperationCode] = operEquip
        })

      })

      // 显示流程设计
      this.$refs.routeComponent.showEmptyFlow()
    },
    loadRouteList() {
      if (this.selectedPlant == '') {
        this.$message.error('请先选择工厂！')
        return
      }
      let queryArgs = {
        QueryPlantCode: this.selectedPlant
      }
      request({
        url: 'Kanban/PartRoute_RouteList',
        method: 'post',
        data: queryArgs
      }).then(response => {
        const res = response
        var routeData = res.data.Data
        this.RouteList = routeData
      })

    },
    showSaveDialog() {
      this.SaveRouteVisible = true
      this.SaveRoute_Model = {}
    },
    confirmSaveRoute() {
      if (this.SaveRoute_Model.RouteCode == '') {
        this.$message.error('请先填写工艺流程代码及名称！')
        return
      }
      this.SaveRouteVisible = false
      this.RouteList.push({
        RouteCode: this.SaveRoute_Model.RouteCode,
        RouteName: this.SaveRoute_Model.RouteName
      })
      this.selectedRoute = this.SaveRoute_Model.RouteCode
      this.$refs.routeComponent.showEmptyFlow()
    },
    saveRouteFlow() {
      const { loadRouteList, refreshRouteFlow } = this

      /*
      if (this.SaveRoute_Model.PartNo == '') {
        this.$message.error('请先选择产品！')
        return
      }
      if (this.SaveRoute_Model.RouteCode == '') {
        this.$message.error('请先填写工艺流程代码及名称！')
        return
      }
      */
      let routeArgs = {}
      /*
      routeArgs.RouteID = this.SaveRoute_Model.RouteID
      routeArgs.PartNo = this.SaveRoute_Model.PartNo
      routeArgs.RouteCode = this.SaveRoute_Model.RouteCode
      routeArgs.RouteName = this.SaveRoute_Model.RouteName
      routeArgs.Memo = this.SaveRoute_Model.Memo
      */
      routeArgs.RouteCode = this.selectedRoute
      this.RouteList.forEach(x => {
        if (x.RouteCode == this.selectedRoute) {
          routeArgs.RouteName = x.RouteName
        }
      })
      // 工序
      let elements = this.$refs.routeComponent.getElements()
      var nodes = []
      elements.forEach(item => {
        var nodeTmp = item.data()
        var pos = item.position()
        nodeTmp.position = pos
        nodes.push(nodeTmp)
      })
      routeArgs.Nodes = nodes

      let postArgs = {
        QueryPlantCode: this.selectedPlant,
        ExtValue: JSON.stringify(routeArgs)
        //ExtValue: routeArgs
      }
      let postArgs2 = {
        data: JSON.stringify(postArgs)
      }
      this.loadingSave = true
      request({
        url: 'Kanban/PartRoute_SaveRouteFlow',
        method: 'post',
        data: postArgs
      }).then(response => {
        this.loadingSave = false
        const res = response
        if (res.data != undefined) {
          this.SaveRouteVisible = false
          // 刷新
          loadRouteList()
          this.selectedRoute = routeArgs.RouteCode
          refreshRouteFlow()
        }
      })

    },
    refreshRouteFlow() {
      /*
      if (this.CurrentPartNo == '') {
        this.$message.error('请先选择产品！')
        return
      }
      */
      if (this.selectedRoute == '') {
        this.$message.error('请先选择工艺流程！')
        return
      }

      let postArgs = {
        QueryPlantCode: this.selectedPlant,
        QueryPartNo: this.CurrentPartNo,
        QueryRouteCode: this.selectedRoute
      }
      request({
        url: 'Kanban/PartRoute_RouteFlow',
        method: 'post',
        data: postArgs
      }).then(response => {
        const res = response
        if (res.data.Data != undefined) {
          this.$refs.routeComponent.loadRouteFlow(res.data.Data)
        }
        
      })

    },
    cyZoomIn() {
      this.$refs.routeComponent.zoomIn()
    },
    cyZoomOut() {
      this.$refs.routeComponent.zoomOut()
    },
    cyZoomFit() {
      this.$refs.routeComponent.zoomFit()
    }
  }
};
</script>
<style lang="less">
#OperEnergy-designer {
  width: 100%;
  height: 100%;
  background-color: #1B2445;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1B2445;
  }
  .block-top-line {
    //background-color: #1D2647;
    background-color: #313C5E;
    width: 100%; 
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #1B2445;
  }
  .route-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-right: 30px;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 0px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 45%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button {
    height: 40px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    background-color: #1B2445;
    height: 50px;
  }
  .block-top-button-field {
    background-color: #1B2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .block-top-button-field /deep/ .el-input__inner {
    background-color: #1B2445;
    color: #fff;
  }
  .block-top-model {
    height: 100px;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .el-table__body tr.current-row>td {
    color: #fff;
    background-color: #a2a4a7 !important;
  }
}

.el-select .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-input__inner {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
  font-size: 22px;
}
.el-cascader .el-cascader__tags .el-tag {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0;
  color: #ffffff;
}

</style>

